import { render } from "./ViewInstance.vue?vue&type=template&id=84b730f8&ts=true"
import script from "./ViewInstance.vue?vue&type=script&lang=ts"
export * from "./ViewInstance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__